import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { FormicaSelectBoxItem } from '../../components/custom/FormicaSearchSelectBox';
import { CaseGraphFieldState, TransactionState } from '../reducers/GraphReducer';
import { GraphInformationJsonModel } from '../../domain/graph/GraphDomains';

export type GraphAction =
  | 'CHANGE_GRAPH_FIELDS'
  | 'CHANGE_SELECTED_FIELDS'
  | 'CHANGE_LOADING'
  | 'CHANGE_GRAPH_LOADING'
  | 'CHANGE_NODE_LIMIT'
  | 'CHANGE_SELECTED_TRANSACTION'
  | 'CHANGE_TRANSACTIONS'
  | 'CHANGE_GRAPH_RESPONSE'
  | 'CHANGE_SELECTED_NODE'
  | 'CHANGE_INFORMATION_VISIBLE'
  | 'CHANGE_INFORMATION_COORDINATES'
  | 'CHANGE_UPDATE'
  | 'CLEAR_GRAPH';

export const changeGraphFields = (payload: CaseGraphFieldState | undefined) =>
  ({
    type: 'CHANGE_GRAPH_FIELDS',
    payload,
  }) as ReduxBaseAction<CaseGraphFieldState, GraphAction>;

export const changeSelectedFields = (payload: FormicaSelectBoxItem[]) =>
  ({
    type: 'CHANGE_SELECTED_FIELDS',
    payload,
  }) as ReduxBaseAction<FormicaSelectBoxItem[], GraphAction>;

export const changeLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, GraphAction>;

export const changeGraphLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_GRAPH_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, GraphAction>;

export const changeNodeLimit = (payload: number) =>
  ({
    type: 'CHANGE_NODE_LIMIT',
    payload,
  }) as ReduxBaseAction<number, GraphAction>;

export const changeSelectedTransaction = (payload: string) =>
  ({
    type: 'CHANGE_SELECTED_TRANSACTION',
    payload,
  }) as ReduxBaseAction<string, GraphAction>;

export const changeTransactions = (payload: TransactionState[]) =>
  ({
    type: 'CHANGE_TRANSACTIONS',
    payload,
  }) as ReduxBaseAction<TransactionState[], GraphAction>;

export const changeResponse = (payload: any) =>
  ({
    type: 'CHANGE_GRAPH_RESPONSE',
    payload,
  }) as ReduxBaseAction<any, GraphAction>;

export const changeSelectedNode = (payload: GraphInformationJsonModel) =>
  ({
    type: 'CHANGE_SELECTED_NODE',
    payload,
  }) as ReduxBaseAction<GraphInformationJsonModel, GraphAction>;

export const changeInformationVisible = (payload: boolean) =>
  ({
    type: 'CHANGE_INFORMATION_VISIBLE',
    payload,
  }) as ReduxBaseAction<boolean, GraphAction>;

export const changeInformationCoordinates = (payload: { x: number; y: number }) =>
  ({
    type: 'CHANGE_INFORMATION_COORDINATES',
    payload,
  }) as ReduxBaseAction<{ x: number; y: number }, GraphAction>;

export const changeUpdate = (payload: number) =>
  ({
    type: 'CHANGE_UPDATE',
    payload,
  }) as ReduxBaseAction<number, GraphAction>;

export const clearGraph = () =>
  ({
    type: 'CLEAR_GRAPH',
  }) as ReduxBaseAction<undefined, GraphAction>;
